export default {
    server_response: (attribute: string) => `${attribute}`,
    attach_csv_first: () => 'Vedhæft venligst csv først',
    please_attach_first: () => 'Vedhæft venligst filen',
    please_create_facility_before_uploading_photos: () => 'Opret facilitet, før du uploader fotos',
    from_and_till_times_are_required: () => 'Fra og til-tider er påkrævet',
    please_select_at_least_one_day: () => 'Vælg mindst en dag',
    please_select_at_least_one_project: () => 'Vælg mindst et projekt',
    event_start_time_must_be_before_event_end_time: () => 'Begivenhedens starttidspunkt skal være før sluttidspunktet for begivenheden',
    offer_has_been_closed_at: (attribute: string) => `Dette tilbud er lukket kl ${attribute}`,
    offer_has_been_archived_at: (attribute: string) => `Dette tilbud er arkiveret kl ${attribute}`,
    at_least_one_applicant_should_be_selected: () => 'Mindst en ansøger skal vælges',
    deadline_date_is_required: () => 'Deadline er påkrævet',
    deadline_and_presentation_dates_are_required: () => 'Deadline og præsentationsdatoer er påkrævet',
    deadline_date_should_be_later_then_today: () => 'Deadline skal være senere end i dag',
    deadline_and_presentation_dates_should_be_later_then_today: () => 'Deadline og præsentationsdatoer skal være senere i dag',
    tag_already_exists_in_interests_list: () => 'Tag findes allerede i interesselisten',
    tag_already_exists_in_educational_list: () => 'Tag findes allerede på uddannelseslisten',
    tag_has_been_added_please_submit_form_to_save_changes: () => 'Tag er tilføjet. Send formular for at gemme ændringer',
    please_fill_message_field: () => 'Udfyld beskedfeltet',
    please_select_the_category: () => 'Vælg kategori',
    no_previous_tenancy_period_exists: () => 'Ingen tidligere lejeperiode eksisterer',
    please_select_at_least_one_unit: () => 'Vælg mindst en enhed',
    please_select_integration_first: () => 'Vælg først en integration',
    content_field_is_required: () => 'Indholdsfeltet er påkrævet',
    please_select_project_first: () => 'Vælg først projekt',
    grouping_has_been_created: () => 'Gruppering er oprettet',
    grouping_has_been_updated: () => 'Gruppering er opdateret',
    grouping_has_been_deleted: () => 'Gruppering er blevet slettet',
    file_has_been_successfully_uploaded: () => 'Filen blev uploadet',
    error_occurred_on_file_upload: () => 'Der opstod en fejl ved upload af fil',
    text_has_been_updated: () => 'Teksten er blevet opdateret',
    language_has_been_added: () => 'Sprog er tilføjet',
    language_key_has_been_added: () => 'Sprognøgle er tilføjet',
    csv_has_been_imported: () => 'CSV er blevet importeret',
    unit_is_already_occupied: () => 'Enheden er allerede optaget',
    tenant_has_been_assigned: () => 'Lejer er tildelt',
    presentation_has_been_created: () => 'Præsentation er oprettet',
    presentation_has_been_updated: () => 'Præsentationen er opdateret',
    presentation_has_been_changed_as_deadline_reached: () => 'Præsentation er ændret, når deadline er nået',
    offer_has_been_re_open: () => 'Tilbuddet er genåbnet',
    offer_has_been_completed: () => 'Tilbuddet er afsluttet',
    user_has_already_been_assigned_to_another_unit: () => 'Brugeren er allerede tildelt en anden enhed. Åbn venligst tilbuddet igen',
    unit_is_already_occupied_please_reopen_and_close_the_offer: () => 'Enheden er allerede optaget. Åbn igen og luk tilbuddet',
    offer_has_been_declined: () => 'Tilbuddet er allerede afvist',
    offer_has_been_closed: () => 'Tilbuddet er lukket',
    unit_dates_has_been_updated_successfully: () => 'Enhedsdatoer er blevet opdateret',
    facility_has_active_bookings_please_cancel_them_before_delete: () => 'Faciliteten har aktive bookinger. Annuller dem inden sletning',
    facility_has_been_deleted: () => 'Faciliteten er blevet slettet',
    booking_has_been_canceled: () => 'Reservationen er annulleret',
    facility_has_been_created: () => 'Facilitet er oprettet',
    facility_has_been_updated: () => 'Faciliteten er blevet opdateret',
    facility_photos_has_been_updated: () => 'Facilitetsbilleder er blevet opdateret',
    facility_photos_order_has_been_updated: () => 'Ordren på facilitetsbilleder er blevet opdateret',
    facility_availability_has_been_updated: () => 'Tilgængelighed af faciliteter er blevet opdateret',
    tag_has_been_created_and_added_to_your_interests: () => 'Tag er oprettet føjet til dine interesser',
    tag_has_been_created_and_added_to_your_educational_institution: () => 'Tag er oprettet og føjet til din uddannelsesinstitution',
    application_has_been_accepted: () => 'Ansøgning er accepteret',
    application_has_been_rejected: () => 'Ansøgning er blevet afvist',
    application_status_toggle: (attribute: string) => `Ansøgning er ${attribute} nu`,
    expiration_emails_has_been_sent: () => 'Udløbs-e-mails er sendt',
    application_has_been_deleted: () => 'Ansøgning er blevet slettet',
    application_data_has_been_updated: () => 'Applikationsdata er opdateret',
    profiling_data_has_been_updated: () => 'Profileringsdata er blevet opdateret',
    personal_data_has_been_updated: () => 'Personlige data er blevet opdateret',
    profile_image_has_been_updated_successfully: () => 'Profilbillede er opdateret',
    reset_password_has_been_sent: () => 'Nulstil adgangskode er sendt',
    profile_date_has_been_updated_successfully: () => 'Profildata er blevet opdateret',
    password_has_been_changed_successfully: () => 'Adgangskoden er ændret',
    ticket_has_been_added: () => 'Billet er tilføjet',
    ticket_has_been_updated: () => 'Billetten er opdateret',
    inquiry_has_been_created: () => 'Forespørgsel er oprettet',
    inquiry_has_been_updated: () => 'Forespørgsel er opdateret',
    inquiry_has_been_deleted: () => 'Forespørgsel er slettet',
    inquiry_cannot_be_deleted_as_it_has_assigned_tickets: () => 'Forespørgsel kan ikke slettes, da den har tildelt billetter',
    category_has_been_created: () => 'Kategori er oprettet',
    category_has_been_updated: () => 'Kategori er blevet opdateret',
    category_has_been_deleted: () => 'Kategori er blevet slettet',
    category_cannot_be_deleted_as_it_has_assigned_inquiries: () => 'Kategori kan ikke slettes, da den har tildelt forespørgsler',
    application_has_been_updated: () => 'Ansøgning er opdateret',
    max_bookings: (amount: string) => `Max ${amount} tilladt`,
    max_bookable_slots_cannot_be_zero: () => 'Maks reserveres slots kan ikke være 0',
    select_project_first: () => 'Vælg venligst projektet først',
    select_project_unit_first: () => 'Vælg venligst projekt og enhed først',
    select_project_category_first: () => 'Vælg venligst projekt og kategori først',
    select_project_type_first: () => 'Vælg venligst projekt og skriv først',
    upcoming_tenant_has_been_reverted: () => 'Kommende lejer er blevet ændret til ansøger',
    upcoming_tenant_move_in_has_been_canceled: () => 'Den kommende indflytning er blevet annulleret',

    // Abuse
    conversation_reported: () => 'Samtalen er blevet reporteret',
    user_blocked: () => 'Brugeren er blevet blokeret',
    conversation_hidden: () => 'Samtalen er nu skjult',
};
